// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload {
  background-color: #fff;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px 10px 10px;
}
.file-upload .file-upload-btn {
  width: 100%;
  margin: 0;
  color: #fff;
  background: #5b84b1;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #5b84b1;
  transition: all 0.2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
}
.file-upload .file-upload-btn:hover {
  background: #5b84b1;
  color: #fff;
  transition: all 0.2s ease;
  cursor: pointer;
}
.file-upload .file-upload-btn:active {
  border: 0;
  transition: all 0.2s ease;
}
.file-upload .file-upload-content {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0;
  overflow: scroll;
  max-height: 150px;
}
.file-upload .file-upload-content label.file-name {
  float: left;
  width: 100%;
}
.file-upload .file-upload-content label.remove-btn {
  padding: 10px 5px 5px 5px;
  float: right;
}
.file-upload .file-upload-input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
  cursor: pointer;
}
.file-upload .image-upload-wrap {
  margin-top: 10px;
  border: 4px dashed #5b84b1;
  position: relative;
}
.file-upload .image-title-wrap {
  padding: 0 15px 15px 15px;
  color: #222;
}
.file-upload .drag-text {
  text-align: center;
}
.file-upload .drag-text h4 {
  font-weight: 100;
  text-transform: uppercase;
  color: #5b84b1;
  padding: 60px 0;
}
.file-upload .file-upload-image {
  max-height: 200px;
  max-width: 200px;
  margin: auto;
  padding: 20px;
}
.file-upload .remove-image {
  width: 200px;
  margin: 0;
  color: #fff;
  background: #cd4535;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #b02818;
  transition: all 0.2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
}
.file-upload .remove-image:hover {
  background: #c13b2a;
  color: #fff;
  transition: all 0.2s ease;
  cursor: pointer;
}
.file-upload .remove-image:active {
  border: 0;
  transition: all 0.2s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/fileupload/fileupload.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B","sourcesContent":[".file-upload {\n  background-color: #fff;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 10px 10px 10px;\n}\n.file-upload .file-upload-btn {\n  width: 100%;\n  margin: 0;\n  color: #fff;\n  background: #5b84b1;\n  border: none;\n  padding: 10px;\n  border-radius: 4px;\n  border-bottom: 4px solid #5b84b1;\n  transition: all 0.2s ease;\n  outline: none;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n.file-upload .file-upload-btn:hover {\n  background: #5b84b1;\n  color: #fff;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n.file-upload .file-upload-btn:active {\n  border: 0;\n  transition: all 0.2s ease;\n}\n.file-upload .file-upload-content {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 0;\n  overflow: scroll;\n  max-height: 150px;\n}\n.file-upload .file-upload-content label.file-name {\n  float: left;\n  width: 100%;\n}\n.file-upload .file-upload-content label.remove-btn {\n  padding: 10px 5px 5px 5px;\n  float: right;\n}\n.file-upload .file-upload-input {\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  outline: none;\n  opacity: 0;\n  cursor: pointer;\n}\n.file-upload .image-upload-wrap {\n  margin-top: 10px;\n  border: 4px dashed #5b84b1;\n  position: relative;\n}\n.file-upload .image-title-wrap {\n  padding: 0 15px 15px 15px;\n  color: #222;\n}\n.file-upload .drag-text {\n  text-align: center;\n}\n.file-upload .drag-text h4 {\n  font-weight: 100;\n  text-transform: uppercase;\n  color: #5b84b1;\n  padding: 60px 0;\n}\n.file-upload .file-upload-image {\n  max-height: 200px;\n  max-width: 200px;\n  margin: auto;\n  padding: 20px;\n}\n.file-upload .remove-image {\n  width: 200px;\n  margin: 0;\n  color: #fff;\n  background: #cd4535;\n  border: none;\n  padding: 10px;\n  border-radius: 4px;\n  border-bottom: 4px solid #b02818;\n  transition: all 0.2s ease;\n  outline: none;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n.file-upload .remove-image:hover {\n  background: #c13b2a;\n  color: #fff;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n.file-upload .remove-image:active {\n  border: 0;\n  transition: all 0.2s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
